var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 103,
    viewBox: "0 0 92 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8825 40.7464C22.345 40.5959 25.3807 40.5959 29.2848 40.5959H62.7154C66.6194 40.5959 69.6554 40.5959 72.1177 40.7464M19.8825 40.7464C16.8094 40.9339 14.6291 41.3559 12.7682 42.304C9.81958 43.8063 7.42229 46.2034 5.9199 49.152C4.21191 52.5045 4.21191 56.8923 4.21191 65.6688V72.9818C4.21191 81.7583 4.21191 86.1461 5.9199 89.4985C7.42229 92.4472 9.81958 94.8443 12.7682 96.3466C16.1203 98.0547 20.5085 98.0547 29.2848 98.0547H62.7154C71.4919 98.0547 75.8797 98.0547 79.2322 96.3466C82.1808 94.8443 84.5779 92.4472 86.0802 89.4985C87.7883 86.1461 87.7883 81.7583 87.7883 72.9818V65.6688C87.7883 56.8923 87.7883 52.5045 86.0802 49.152C84.5779 46.2034 82.1808 43.8063 79.2322 42.304C77.371 41.3559 75.1907 40.9339 72.1177 40.7464M19.8825 40.7464V30.1489C19.8825 15.7245 31.5758 4.03125 46.0001 4.03125C60.4243 4.03125 72.1177 15.7245 72.1177 30.1489V40.7464",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2117 65.1816C42.3675 65.6183 41.6106 66.3461 41.0866 67.2194C39.3108 70.0723 40.3006 73.9442 43.2117 75.4871C44.9584 76.4478 47.8696 76.3605 49.3834 75.3124C51.2174 74.0315 51.7997 72.8671 51.7997 70.3344C51.7997 67.8016 51.2174 66.6372 49.3834 65.3563C47.8696 64.3082 44.9584 64.2209 43.2117 65.1816Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.83fa1f9f09fc1bf9447487dc6a6a6ffc.svg";
export { ForwardRef as ReactComponent };